import { features } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
            为什么选择久播影院
          </h2>
          <p className="text-sm text-foreground-600">
            四大核心优势，打造极致观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {features.map((f, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70 text-center group hover:border-primary-200/50 transition-all duration-300"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 md:mb-4 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${f.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {f.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {f.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}